<template>
  <v-dialog persistent width="90%" v-model="active">
    <v-card color="primary" class="rounded-sm">
      <v-card-title>
        <div class="text-h6">Evaluación de renidmiento y profesionalismo</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text v-if="rendimientoProfesionalismo">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Información general</div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          label="Evaluado"
                          :value="getFullName(rendimientoProfesionalismo.Personal)"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="Evaluador"
                          :value="getFullName(rendimientoProfesionalismo.PersonalEvaluador)"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="rendimientoProfesionalismo.CatMunicipio.nombre"
                          label="Municipio"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="rendimientoProfesionalismo.fechaInicial"
                          label="Fecha Inicial"
                          append-icon="mdi-calendar"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="rendimientoProfesionalismo.fechaFin"
                          label="Fecha fin"
                          append-icon="mdi-calendar"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="rendimientoProfesionalismo.fechaAplicacion"
                          label="Fecha de aplicación"
                          append-icon="mdi-calendar"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          label="Institución de seguridad pública a la que aspira"
                          v-model="rendimientoProfesionalismo.institucionSeguridadAspira"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="Aspirante al puesto de"
                          v-model="rendimientoProfesionalismo.aspiranteAlPuesto"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Reactivos</div>
                </v-card-title>
                <v-card-text v-if="rendimientoProfesionalismo.frecuenciasMedicion.length > 0">
                  <v-container>
                    <v-row>
                      <v-col cols="12" v-for="(reactivo, index) in reactivos" :key="index">
                        <v-row align="center">
                          <v-col cols="1">
                            {{ index + 1 }}
                          </v-col>
                          <v-col cols="8">
                            <div class="text-subtitle-2">{{ reactivo.CatReactivo.title }}</div>
                          </v-col>
                          <v-col>
                            <v-select
                              label="Frecuencia de medición"
                              v-model="rendimientoProfesionalismo.frecuenciasMedicion[index].fk_idCatFrecuencia"
                              rounded
                              filled
                              dense
                              :items="frecuencia"
                              item-value="id"
                              item-text="title"
                              item-color="secondary"
                              color="secondary"
                              background-color="transparent"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-divider class="my-2"></v-divider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Observaciones</div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          label="Observaciones"
                          v-model="rendimientoProfesionalismo.observaciones"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="transparent"
                          no-resize
                          rows="3"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Resultados</div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="4">
                        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
                          <v-card-title class="d-block">
                            <div class="text-caption">Resultado</div>
                            <div class="text-subtitle-1">{{ getResultado }}</div>
                          </v-card-title>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
                          <v-card-title class="d-block">
                            <div class="text-caption">Puntaje total</div>
                            <div class="text-subtitle-1">{{ getPuntajeTotal }}</div>
                          </v-card-title>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
                          <v-card-title class="d-block">
                            <div class="text-caption">Calificación</div>
                            <div class="text-subtitle-1">{{ getCalificacion }}</div>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="secondary" @click="triggerSaveRendimientoProfesionalismo()" :loading="loading"
          >Guardar evaluación</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
    },

    rendimientoProfesionalismo: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters('reactivosEvaluacion', {
      reactivos: 'getReactivosRendimientoProfesionalismo',
    }),

    ...mapGetters('frecuenciaRespetoPrincipio', {
      frecuencia: 'getFrecuenciaRespetoPrincipio',
    }),

    ...mapGetters('resultado', {
      resultado: 'getResultado',
    }),

    getResultado: function () {
      // TODO: Ligar resultado con objeto a actualizar, ya que siempre lo deja con resultado Excelente
      if (this.getPuntajeTotal <= 35) {
        this.rendimientoProfesionalismo.fk_idResultado = 5
        return 'No satisfactorio'
      } else if (this.getPuntajeTotal > 35 && this.getPuntajeTotal < 42) {
        this.rendimientoProfesionalismo.fk_idResultado = 4
        return 'Insuficiente'
      } else if (this.getPuntajeTotal > 41 && this.getPuntajeTotal < 48) {
        this.rendimientoProfesionalismo.fk_idResultado = 3
        return 'Satisfactorio'
      } else if (this.getPuntajeTotal > 47 && this.getPuntajeTotal < 54) {
        this.rendimientoProfesionalismo.fk_idResultado = 2
        return 'Sobresaliente'
      } else if (this.getPuntajeTotal > 53) {
        this.rendimientoProfesionalismo.fk_idResultado = 1
        return 'Excelente'
      }
    },

    getPuntajeTotal: function () {
      if (this.rendimientoProfesionalismo) {
        var puntajeTotal = 0
        this.rendimientoProfesionalismo.frecuenciasMedicion.forEach((reactivo) => {
          switch (reactivo.fk_idCatFrecuencia) {
            case 1:
              puntajeTotal = puntajeTotal + 4
              break
            case 2:
              puntajeTotal = puntajeTotal + 3
              break
            case 3:
              puntajeTotal = puntajeTotal + 2
              break
            case 4:
              puntajeTotal = puntajeTotal + 1

              break
            case 5:
              puntajeTotal = puntajeTotal + 0
              break
            default:
              break
          }
        })

        return puntajeTotal
      }
    },

    getCalificacion: function () {
      if (this.getPuntajeTotal == 0) {
        return '0'
      } else if (this.getPuntajeTotal > 1 && this.getPuntajeTotal < 36) {
        return '5'
      } else if (this.getPuntajeTotal > 35 && this.getPuntajeTotal < 42) {
        return '6'
      } else if (this.getPuntajeTotal > 41 && this.getPuntajeTotal < 48) {
        return '7'
      } else if (this.getPuntajeTotal > 47 && this.getPuntajeTotal < 54) {
        return '8'
      } else if (this.getPuntajeTotal > 53 && this.getPuntajeTotal < 57) {
        return '9'
      } else if (this.getPuntajeTotal > 56) {
        return '10'
      }
    },
  },

  methods: {
    ...mapActions('rendimientoProfesionalismo', [
      'updateRendimientoProfesionalismo',
      'updateEstatusRendimientoProfesionalismo',
    ]),
    ...mapActions('reactivosEvaluacion', ['fetchReactivosEvaluacion']),
    ...mapActions('evaluacionesPersonal', ['fetchEvaluacionesById']),

    triggerSaveRendimientoProfesionalismo: async function () {
      this.loading = true
      this.rendimientoProfesionalismo.puntajeTotal = this.getPuntajeTotal
      this.rendimientoProfesionalismo.calificacion = this.getCalificacion
      await this.updateRendimientoProfesionalismo(this.rendimientoProfesionalismo)
      await this.updateEstatusRendimientoProfesionalismo(this.rendimientoProfesionalismo)
      await this.fetchEvaluacionesById(this.rendimientoProfesionalismo.fk_idPersonalEvaluador)
      this.closeDialog()
    },

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
}

::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

.text-h6 {
  color: #ffffff !important;
}

::v-deep .text-subtitle-2 {
  color: #e0e0e0 !important;
}
</style>
